import React from "react";
import { Box, Button } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";
import ColourConstants from "helpers/colourConstants";
import { ReactComponent as DeleteIcon } from "assets/icons/deleteIcon.svg";

const useStyles = makeStyles()(() => ({
	deleteIcon: {
		transform: "scale(0.7)",
		color: ColourConstants.deleteButton,
		"&:hover": {
			cursor: "pointer",
		},
	},
}));

const SubscriptionActions = ({ onEdit, onDelete }) => {
	const { classes } = useStyles();
	const { t } = useTranslation();
	return (
		<Box
			sx={{
				display: "flex",
				gap: 2,
				alignItems: "center",
				justifyContent: "flex-end",
				mt: 0,
			}}
		>
			<Button onClick={onEdit}>{t("action.edit")}</Button>
			<DeleteIcon className={classes.deleteIcon} onClick={onDelete} />
		</Box>
	);
};

export default SubscriptionActions;
